/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDataProductRequestDto } from '../models/CreateDataProductRequestDto';
import type { DataProductCountPreviewDto } from '../models/DataProductCountPreviewDto';
import type { GetDataProductResponseDto } from '../models/GetDataProductResponseDto';
import type { PreviewDataProductDynamicInputDto } from '../models/PreviewDataProductDynamicInputDto';
import type { SearchCollectionDataProductUpstreamIncidentDto } from '../models/SearchCollectionDataProductUpstreamIncidentDto';
import type { SearchCollectionGetDataProductListResponseDto } from '../models/SearchCollectionGetDataProductListResponseDto';
import type { SearchCollectionV2AssetSummaryDtoV2 } from '../models/SearchCollectionV2AssetSummaryDtoV2';
import type { UpdateDataProductRequestDto } from '../models/UpdateDataProductRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DataProductService {

    /**
     * Get all data product
     * @returns SearchCollectionGetDataProductListResponseDto Successfully fetch all data products
     * @throws ApiError
     */
    public static getAllDataProducts({
        domainId,
    }: {
        domainId: string,
    }): CancelablePromise<SearchCollectionGetDataProductListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/data-products',
            query: {
                'domainId': domainId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a data product
     * @returns any Successfully create Data Product
     * @throws ApiError
     */
    public static createDataProduct({
        requestBody,
    }: {
        requestBody: CreateDataProductRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/data-products',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get assets belonging to data product
     * @returns SearchCollectionV2AssetSummaryDtoV2 Data product assets
     * @throws ApiError
     */
    public static getDataProductAssets({
        dataProductId,
        assetFilterType,
        page,
        itemsPerPage = 25,
        sort,
    }: {
        /**
         * Filter on given data product id
         */
        dataProductId: string,
        /**
         * Filter on given asset types
         */
        assetFilterType?: Array<'TABLE_AND_VIEW' | 'PIPELINE' | 'DASHBOARD' | 'MONITOR' | 'ML_MODEL' | 'GENERIC'>,
        /**
         * The requested page number. Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The number of elements to be returned inside the page. Pass a value of -1, to bypass pagination and fetch all items
         */
        itemsPerPage?: number,
        /**
         * The resource fields on which to apply the sort, format : property,ASC|DESC
         */
        sort?: Array<string>,
    }): CancelablePromise<SearchCollectionV2AssetSummaryDtoV2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/data-products/assets',
            query: {
                'assetFilterType': assetFilterType,
                'dataProductId': dataProductId,
                'page': page,
                'itemsPerPage': itemsPerPage,
                'sort': sort,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Count data product dynamic input result
     * @returns DataProductCountPreviewDto Successfully previewed query count
     * @throws ApiError
     */
    public static previewDataProductDynamicCount({
        requestBody,
    }: {
        requestBody: PreviewDataProductDynamicInputDto,
    }): CancelablePromise<DataProductCountPreviewDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/data-products/count-preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a data product
     * @returns void
     * @throws ApiError
     */
    public static deleteDataProduct({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/ui/v1/data-products/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get data product by id
     * @returns GetDataProductResponseDto Successfully fetch a data product by id
     * @throws ApiError
     */
    public static getDataProduct({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetDataProductResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/data-products/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update a data product
     * @returns any Successfully update Data Product
     * @throws ApiError
     */
    public static updateDataProduct({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateDataProductRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/ui/v1/data-products/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get upstream incidents for a data product
     * @returns SearchCollectionDataProductUpstreamIncidentDto Upstream incidents page
     * @throws ApiError
     */
    public static getDataProductUpstreamIncidents({
        id,
        page,
        itemsPerPage = 25,
    }: {
        id: string,
        /**
         * The requested page number. Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The number of elements to be returned inside the page. Pass a value of -1, to bypass pagination and fetch all items
         */
        itemsPerPage?: number,
    }): CancelablePromise<SearchCollectionDataProductUpstreamIncidentDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/data-products/{id}/upstream-incidents',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'itemsPerPage': itemsPerPage,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
